import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import transaction from './modules/transaction';
import stanbic from './modules/stanbic';
import polaris from './modules/polaris';
import sterling from './modules/sterling';
import first from './modules/first';
import fidelity from './modules/fidelity';
import klump from './modules/klump';
import renmoney from './modules/renmoney';
import creditDirect from './modules/creditDirect';
import wema from './modules/wema';
import veend from './modules/veend';
import refundWallet from './modules/refundWallet';

Vue.use(Vuex);

const initialState = {
	auth: auth.state,
	transaction: transaction.state,
	stanbic: stanbic.state,
	polaris: polaris.state,
	sterling: sterling.state,
	renmoney: renmoney.state,
	fidelity: fidelity.state,
	creditDirect: creditDirect.state,
	wema: wema.state,
	veend: veend.state
};

const store = new Vuex.Store({
	state: {
		errorMessage: null,
		alert: null,
		status: '',
		userOnlineStatus: true,
		merchantChannel: null,
		flutterwaveIframeListener: false,
		isUsedAsIFrame: false,
		distinct_id: window.location.search !== ''
			? window.location.search.split('?mixpanel_distinct_id=')[1]
			: Date.now(),
		modalNameBeforeUnsuccessfulError: null,
		bankRecordFailureCounter: 0,
		verifyUserIdPayload: null,
		isMonoAuthCodeError: false,
		bankRecord2MinutesFailure: false,
		activeLogo: 'klump',
		installment: null,
		repaymentDay: null,
		selectedInstitution: null,
		nextModal: null,
		phoneNumber: null,
		userTypedData: null,
		userPartnerToken: null,
		previousModal: [],
		queryTransactionStatus: null,
		hideKlumpFlow: true,
		hideRenmoneyFlow: true,
		hideFirstBankFlow: true,
		hideCreditDirectFlow: true,
		newUser: false,
		transactionReference: null,
		isUserEmailOrPhoneNumberDataTyped: false
	},
	getters: {
		getErrorMessage: (state) => state.errorMessage,
		getAlert: (state) => state.alert,
		getStatus: (state) => state.status,
		getUserOnlineStatus: (state) => state.userOnlineStatus,
		getMerchantChannel: (state) => state.merchantChannel,
		getFlutterwaveIframeListener: (state) => state.flutterwaveIframeListener,
		getIfCheckoutIsUsedAsIframe: (state) => state.isUsedAsIFrame,
		getDistinctId: (state) => state.distinct_id,
		getModalNameBeforeUnsuccessfulError: (state) => state.modalNameBeforeUnsuccessfulError,
		getBankRecordFailureCounter: (state) => state.bankRecordFailureCounter,
		getVerifyUserIdPayload: (state) => state.verifyUserIdPayload,
		getIsMonoAuthCodeError: (state) => state.isMonoAuthCodeError,
		getBankRecord2MinutesFailure: (state) => state.bankRecord2MinutesFailure,
		getActiveLogo: (state) => state.activeLogo,
		getInstallment: (state) => state.installment,
		getRepaymentDay: (state) => state.repaymentDay,
		getSelectedInstitution: (state) => state.selectedInstitution,
		getNextModal: (state) => state.nextModal,
		getPreviousModal: (state) => state.previousModal,
		getPhoneNumber: (state) => state.phoneNumber,
		getUserTypedData: (state) => state.userTypedData,
		getUserPartnerToken: (state) => state.userPartnerToken,
		getQueryTransactionStatus: (state) => state.queryTransactionStatus,
		getHideKlumpFlow: (state) => state.hideKlumpFlow,
		getHideRenmoneyFlow: (state) => state.hideRenmoneyFlow,
		getHideFirstBankFlow: (state) => state.hideFirstBankFlow,
		getHideCreditDirectFlow: (state) => state.hideCreditDirectFlow,
		getNewUser: (state) => state.newUser,
		getTransactionReference: (state) => state.transactionReference,
		getIsUserEmailOrPhoneNumberDataTyped: (state) => state.isUserEmailOrPhoneNumberDataTyped
	},
	mutations: {
		setErrorMessage: (state, data) => {
			state.errorMessage = data;
		},
		clearErrorMessage: (state) => {
			state.errorMessage = null;
		},
		reqInit: (state) => {
			state.status = 'loading';
			state.errorLog = {};
		},
		reqSuccess: (state) => {
			state.status = 'success';
		},
		reqError: (state) => {
			state.status = 'error';
		},
		logError: (state, data) => {
			state.errorLog = data;
		},
		clearErrorStatus: (state) => {
			setTimeout(() => {
				state.status = '';
			}, 2000);
		},
		resetReq: (state) => {
			state.status = '';
			state.errorLog = {};
		},
		resetAll: (state) => {
			Object.keys(state).forEach((key) => {
				Object.assign(state[key], initialState[key]);
			});
		},
		clearAlert: (state) => {
			state.alert = null;
		},
		setAlert: (state, data) => {
			state.alert = data;
		},
		setUserOnlineStatus: (state, data) => {
			state.userOnlineStatus = data;
		},
		setMerchantChannel: (state, channel) => {
			state.merchantChannel = channel;
		},
		setIframeResponseOnSuccess: (state, data) => {
			state.merchantChannel.source.postMessage(
				JSON.stringify({
					data
				}),
				'*'
			);
		},
		setIframeResponseOnError: (state, data) => {
			state.merchantChannel.source.postMessage(
				JSON.stringify({
					data
				}),
				'*'
			);
		},
		setIframeResponseOnLoad: (state, data) => {
			state.merchantChannel.source.postMessage(
				JSON.stringify({
					data
				}),
				'*'
			);
		},
		setIframeResponseOnOpen: (state, data) => {
			state.merchantChannel.source.postMessage(
				JSON.stringify({
					data
				}),
				'*'
			);
		},
		setIframeResponseOnClose: (state, data) => {
			state.merchantChannel.source.postMessage(
				JSON.stringify({
					data
				}),
				'*'
			);
		},
		setFlutterwaveIframeListener: (state, data) => {
			state.flutterwaveIframeListener = data;
		},
		setIfCheckoutIsUsedAsIframe: (state, data) => {
			state.isUsedAsIFrame = data;
		},
		setModalNameBeforeUnsuccessfulError: (state, data) => {
			state.modalNameBeforeUnsuccessfulError = data;
		},
		setBankRecordFailureCounter: (state, count) => {
			state.bankRecordFailureCounter = count;
		},
		setVerifyUserIdPayload: (state, data) => {
			state.verifyUserIdPayload = data;
		},
		setIsMonoAuthCodeError: (state, data) => {
			state.isMonoAuthCodeError = data;
		},
		setBankRecord2MinutesFailure: (state, data) => {
			state.bankRecord2MinutesFailure = data;
		},
		setActiveLogo: (state, data) => {
			state.activeLogo = data;
		},
		setInstallment: (state, data) => {
			state.installment = data;
		},
		setRepaymentDay: (state, data) => {
			state.repaymentDay = data;
		},
		setSelectedInstitution: (state, data) => {
			state.selectedInstitution = data;
		},
		setNextModal: (state, data) => {
			state.nextModal = data;
		},
		setPhoneNumber: (state, data) => {
			state.phoneNumber = data;
		},
		setUserTypedData: (state, data) => {
			state.userTypedData = data;
		},
		setUserPartnerToken: (state, data) => {
			state.userPartnerToken = data;
		},
		setQueryTransactionStatus: (state, data) => {
			state.queryTransactionStatus = data;
		},
		addPreviousModal: (state, data) => {
			state.previousModal.push(data);
		},
		resetPreviousModal: (state) => {
			state.previousModal = [];
		},
		setHideKlumpFlow: (state, data) => {
			state.hideKlumpFlow = data;
		},
		setHideRenmoneyFlow: (state, data) => {
			state.hideRenmoneyFlow = data;
		},
		setHideFirstBankFlow: (state, data) => {
			state.hideFirstBankFlow = data;
		},
		setHideCreditDirectFlow: (state, data) => {
			state.hideCreditDirectFlow = data;
		},
		setNewUser: (state, data) => {
			state.newUser = data;
		},
		setTransactionReference: (state, data) => {
			state.transactionReference = data;
		},
		setIsUserEmailOrPhoneNumberDataTyped: (state, data) => {
			state.isUserEmailOrPhoneNumberDataTyped = data;
		}
	},
	modules: {
		auth,
		transaction,
		stanbic,
		polaris,
		sterling,
		first,
		klump,
		renmoney,
		fidelity,
		creditDirect,
		wema,
		veend,
		refundWallet
	}
});

export default store;
